import React, { useState, useEffect, useContext, useRef } from "react";
import { Breadcrumb, Spin } from "antd";
import DataTable from "../sprawy/components/dataTable";
import { UserContext } from "../components/privateroute";
import { Navigate } from "react-router-dom";
import axios from "axios";

const storageKey = "brakAktywnosciFilterMode";

const BrakAktywnosci = () => {
	const [departs] = useState([]);
	const [showFilters, setShowFilters] = useState(false);
	const globalUser = useContext(UserContext);
	const isAdmin = Boolean(globalUser?.isadmin);
	const adminInitRef = useRef(false);
	const [areasLoaded, setAreasLoaded] = useState(isAdmin);
	const [hasAssignedAreas, setHasAssignedAreas] = useState(isAdmin);
	const [filterMode, setFilterMode] = useState(() => {
		try {
			const saved = localStorage.getItem(storageKey);
			return saved === "tags" || saved === "areas" ? saved : "areas";
		} catch {
			return "areas";
		}
	});

	React.useEffect(() => {
		try {
			localStorage.setItem(storageKey, filterMode);
		} catch {
			// ignore storage errors
		}
	}, [filterMode]);
	const [showAllTickets, setShowAllTickets] = useState(false);
	const activityDays = 180;

	useEffect(() => {
		if (adminInitRef.current) return;
		if (isAdmin) {
			setShowAllTickets(true);
			adminInitRef.current = true;
		}
	}, [isAdmin]);

	useEffect(() => {
		let mounted = true;

		const loadAreas = async () => {
			if (isAdmin) {
				if (mounted) {
					setHasAssignedAreas(true);
					setAreasLoaded(true);
				}
				return;
			}

			setAreasLoaded(false);
			try {
				const response = await axios.post("/user/areas/get");
				const list = Array.isArray(response?.data?.data)
					? response.data.data
					: [];
				if (!mounted) return;
				setHasAssignedAreas(list.length > 0);
			} catch {
				if (!mounted) return;
				setHasAssignedAreas(false);
			} finally {
				if (mounted) setAreasLoaded(true);
			}
		};

		loadAreas();

		return () => {
			mounted = false;
		};
	}, [isAdmin]);

	if (!areasLoaded) {
		return <Spin fullscreen />;
	}

	if (!isAdmin && !hasAssignedAreas) {
		return (
			<Navigate
				to="/obszary-dzialania"
				replace
			/>
		);
	}

	return (
		<>
			<Breadcrumb
				style={{
					padding: "20px",
				}}
			>
				<Breadcrumb.Item>Strona główna</Breadcrumb.Item>
				<Breadcrumb.Item>Brak aktywności</Breadcrumb.Item>
			</Breadcrumb>
			<div
				className={["fullHeight, twoColumnsLayout"]}
				align="start"
				style={{
					gap: "0px",
					width: "100%",
					maxWidth: "100%",
					minWidth: 0,
					boxSizing: "border-box",
					overflowX: "hidden",
					background: "white",
					height: "100%",
					display: "grid",
					gridTemplateColumns: "100%",
				}}
			>
				<DataTable
					departs={departs}
					setShowFilters={setShowFilters}
					showFilters={showFilters}
					activityMode="inactive"
					activityDays={activityDays}
					ticketRouteBase="/sprawy/brak-aktywnosci"
					storageKeyPrefix="brakAktywnosci"
					applyUserTerritoryFilter={
						filterMode === "areas" && !showAllTickets
					}
					filterMode={filterMode}
					onFilterModeChange={setFilterMode}
					showAllTickets={showAllTickets}
					onShowAllTicketsChange={setShowAllTickets}
					showRightFiltersPanel
				/>
			</div>
		</>
	);
};

export default BrakAktywnosci;
